<template>
  <div class="dnews blue2 prelative fs16 cpointer ofhidden mb20" @click="goRoute(item.id)">
    <span class="pabsolute ndt fs14">{{item.release_time}}</span>
    {{item.title}}
  </div>
</template>

<script>
export default {
  name: "inquiry-item",
  props: [
    'item'
  ],
  methods:{
    goRoute(id){
      this.$router.push({path:'/train/inquiry/detail',query:{id:id}})
    },
  }
}
</script>

<style scoped>
  .dnews:hover{font-weight: bold;}
  .dnews:hover .ndt{color: #da9f4e;font-weight: normal;}
  .dnews{margin-bottom: 15px;padding-left: 18px;padding-right: 90px;height: 24px;}
  .dnews::before{content: '';position: absolute;left: 5px;top: 8px;width: 5px;height: 5px;border-radius: 50%;background: #c9c9c9;}
  .dnews .nm{height: 16px;}
  .dnews .ndt{top: 2px;right: 0;color: #d3d3d4;}
  .dnews.blue2:hover,.dnews.blue2:hover .ndt{color: #147ad8;}
  .dnews.blue2:hover::before{background: #147ad8;}
</style>



// WEBPACK FOOTER //
// src/components/train/index/inquiry-item.vue